import { render, staticRenderFns } from "./GameLobby.vue?vue&type=template&id=70d36fd6&scoped=true&"
import script from "./GameLobby.vue?vue&type=script&lang=js&"
export * from "./GameLobby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d36fd6",
  null
  
)

export default component.exports